import { render, staticRenderFns } from "./LeagueRuns.vue?vue&type=template&id=f140d354&scoped=true"
import script from "./LeagueRuns.vue?vue&type=script&lang=js"
export * from "./LeagueRuns.vue?vue&type=script&lang=js"
import style0 from "./LeagueRuns.vue?vue&type=style&index=0&id=f140d354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140d354",
  null
  
)

export default component.exports